import React from 'react';
import { flexRender } from '@tanstack/react-table';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { TableProps } from '../../../../types';
import { TABLE_HEADER_HEIGHT } from './const';

export const TableHeading = <T,>({ table }: Pick<TableProps<T>, 'table'>) => (
  <Box boxSizing="borderBox" as="thead" height={TABLE_HEADER_HEIGHT} color="grey_1100">
    {table.getHeaderGroups().map((headerGroup) => (
      <Box boxSizing="borderBox" as="tr" key={headerGroup.id}>
        {headerGroup.headers.map((header) => (
          <Box
            as="th"
            boxSizing="borderBox"
            key={header.id}
            colSpan={header.colSpan}
            textAlign={header.column.columnDef?.meta?.align || 'start'}
            paddingY="2"
            paddingX="4"
            borderTopLeftRadius="sm"
            borderTopRightRadius="sm"
            backgroundColor="grey_100"
            borderStyle="solid"
            borderWidth={0}
            borderBottomWidth="sm"
            borderColor="grey_400"
            className={header.column.columnDef.meta?.className}
          >
            {header.isPlaceholder ? null : (
              <Text as="p" size="b_sm" fontWeight="semibold">
                {flexRender(header.column.columnDef.header, header.getContext())}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);
